import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

export default function Pricing() {
  const plans = [
    {
      name: 'Free',
      price: 'LKR 0',
      period: 'forever',
      description: 'Perfect for getting started on HIVE.',
      highlight: false,
      features: ['List 1 service', 'Appear in search results', 'Receive customer messages', 'Basic profile page', 'HIVE badge on profile'],
      cta: 'Get Started Free',
      ctaStyle: 'bg-gray-900 dark:bg-white text-white dark:text-gray-900',
      href: '/auth',
    },
    {
      name: 'Pro',
      price: 'LKR 990',
      period: 'per month',
      description: 'For serious providers ready to grow.',
      highlight: true,
      features: ['List up to 10 services', 'Priority in search results', 'Verified Pro badge', 'Analytics dashboard', 'Customer reviews enabled', 'Featured profile listing'],
      cta: 'Go Pro',
      ctaStyle: 'bg-gradient-to-r from-yellow-400 to-yellow-500 text-white',
      href: '/auth',
    },
    {
      name: 'Business',
      price: 'LKR 2,490',
      period: 'per month',
      description: 'For teams and high-volume providers.',
      highlight: false,
      features: ['Unlimited service listings', 'Top placement in search', 'Business verification badge', 'Team account (3 members)', 'Priority customer support', 'Custom profile branding', 'Monthly performance report'],
      cta: 'Contact Us',
      ctaStyle: 'bg-gray-900 dark:bg-white text-white dark:text-gray-900',
      href: '/contact',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white dark:from-gray-900 dark:to-gray-800 transition-colors duration-300">
      <Navigation />

      <section className="relative pt-32 md:pt-40 pb-16 overflow-hidden">
        <div className="absolute top-20 -left-20 w-96 h-96 bg-yellow-400/20 rounded-full blur-3xl pointer-events-none" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-black text-gray-900 dark:text-white mb-4">Simple, Transparent Pricing</h1>
          <p className="text-lg text-gray-600 dark:text-gray-400">Start free. Upgrade when you're ready to grow. No hidden fees.</p>
        </div>
      </section>

      <section className="py-8 pb-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
            {plans.map((plan, i) => (
              <div key={i} className={`relative bg-white/60 dark:bg-gray-800/60 backdrop-blur-xl rounded-2xl border-2 ${plan.highlight ? 'border-yellow-400/50 shadow-yellow-400/20' : 'border-gray-200/50 dark:border-gray-700/50'} shadow-lg hover:shadow-2xl hover:scale-[1.03] transition-all duration-300 ${plan.highlight ? 'scale-105' : ''} p-8 group`}>
                {plan.highlight && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-gradient-to-r from-yellow-400 to-yellow-500 text-white text-xs font-bold rounded-full">
                    Most Popular
                  </div>
                )}
                <h3 className="text-xl font-black text-gray-900 dark:text-white mb-1">{plan.name}</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">{plan.description}</p>
                <div className="mb-6">
                  <span className="text-3xl font-black text-gray-900 dark:text-white">{plan.price}</span>
                  <span className="text-gray-500 dark:text-gray-400 text-sm ml-1">/ {plan.period}</span>
                </div>
                <ul className="space-y-3 mb-8">
                  {plan.features.map((f, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-gray-700 dark:text-gray-300">
                      <CheckCircle className="w-4 h-4 text-yellow-500 flex-shrink-0 mt-0.5" />
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => window.location.href = plan.href}
                  className={`w-full py-3 rounded-xl font-bold text-sm ${plan.ctaStyle} hover:shadow-lg transition-all flex items-center justify-center gap-2`}
                >
                  {plan.cta} <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
          <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-10">
            Customers always use HIVE for free. Pricing above is for service providers only.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}